import Tree from './Tree';
import TreeNode from './TreeNode';

Tree.TreeNode = TreeNode;

export { TreeNode };
export default Tree;


//////////////////
// WEBPACK FOOTER
// ../~/_rc-tree@2.0.0@rc-tree/es/index.js
// module id = 638
// module chunks = 0